import { DirectionalHint } from "@fluentui/react/lib/Callout";
import { IKeytipProps } from "@fluentui/react/lib/Keytip";
import { memoizeFunction } from "@fluentui/react/lib/Utilities";

import { getBoundingWindowWithPaddingFabric } from "@1js/window-util";

const tabOffset = 24; // Tab header keytips should be positioned 24px from the top

export const getDefaultKeytipProps = (
  keytipProps: IKeytipProps,
  offset: number,
  onExecute?: (executeTarget: HTMLElement, target: HTMLElement) => void,
  directionalHint: DirectionalHint = DirectionalHint.topCenter
): IKeytipProps => {
  return {
    onReturn: defaultOnReturn,
    ...keytipProps,
    onExecute,
    calloutProps: {
      coverTarget: true,
      directionalHint,
      gapSpace: offset,
      ...keytipProps.calloutProps,
      bounds: getBoundingWindowWithPaddingFabric,
    },
  };
};

export const defaultOnReturn = (executeTarget: HTMLElement) =>
  executeTarget && executeTarget.focus();

export const deriveTabKeytip = memoizeFunction(
  (
    keytipProps?: IKeytipProps,
    onExecute?: (executeTarget: HTMLElement) => void
  ): IKeytipProps | undefined => {
    return keytipProps
      ? getDefaultKeytipProps(keytipProps, tabOffset, onExecute)
      : undefined;
  }
);

export const deriveInputKeytip = memoizeFunction(
  (
    keytipProps?: IKeytipProps,
    onExecute?: (executeTarget: HTMLElement) => void
  ): IKeytipProps | undefined => {
    return keytipProps
      ? getDefaultKeytipProps(keytipProps, 26, onExecute)
      : undefined;
  }
);
